import { TIME_FORMAT } from "src/common";
import {
  STATE_FETCH_SUCCESS,
  STATE_FETCH_INVOKED,
  STATE_FETCH_FAILED,
  TOGGLE_MESSAGE_COLLAPSED,
  TOGGLE_MESSAGE_COLLAPSED_INVOKED,
  SET_LANGUAGE,
} from "src/redux/actions/user";
import { UserI } from "src/types/User";
import {
  getInitialLanguage,
  SupportedLanguage,
} from "src/i18n/languages";

export const initialState = {
  data: {} as UserI,
  language: getInitialLanguage(),
  loading: true,
  error: null as Error,
};

export type UserState = typeof initialState;

export interface UserMessageI {
  index: number;
  isOpen: boolean;
  companyFeatureId: string;
}

interface UserFetchActionI {
  type: typeof STATE_FETCH_SUCCESS;
  payload: UserI;
}

interface UserToggleMessageActionI {
  type:
    | typeof TOGGLE_MESSAGE_COLLAPSED
    | typeof TOGGLE_MESSAGE_COLLAPSED_INVOKED;
  userMessage: UserMessageI;
}

interface UserErrorActionI {
  type: typeof STATE_FETCH_FAILED;
  error: Error;
}

interface UserFetchInvokeActionI {
  type: typeof STATE_FETCH_INVOKED;
}

interface UserSetLanguageActionI {
  type: typeof SET_LANGUAGE;
  language: SupportedLanguage;
}

export type UserActionI =
  | UserFetchInvokeActionI
  | UserFetchActionI
  | UserToggleMessageActionI
  | UserErrorActionI
  | UserSetLanguageActionI;

const user = (
  state: UserState = initialState,
  action: UserActionI,
): UserState => {
  let newMessages;
  switch (action.type) {
    case STATE_FETCH_INVOKED:
      return {
        ...state,
        loading: true,
      };
    case STATE_FETCH_SUCCESS:
      // // First we must make sure that any missing widgets have defaults applied to them
      // action.payload.widgets = setWidgetDefaults(action.payload.widgets);
      return {
        ...state,
        loading: false,
        data: {
          ...action.payload,
          messages: action.payload.messages?.length
            ? action.payload.messages.sort((a, b) => {
                if (
                  b.feature === "ApplicationMessages" &&
                  a.feature !== "ApplicationMessages"
                )
                  return 1;
                if (
                  a.feature === "ApplicationMessages" &&
                  b.feature !== "ApplicationMessages"
                )
                  return -1;
                else return 0;
              })
            : [],
          dateFormat:
            typeof action.payload.dateTimeFormat === "string"
              ? action.payload.dateTimeFormat.toUpperCase().split(" ")[0]
              : undefined,
          dateTimeFormat:
            typeof action.payload.dateTimeFormat === "string"
              ? `${
                  action.payload.dateTimeFormat.toUpperCase().split(" ")[0]
                } ${TIME_FORMAT}`
              : undefined,
        },
      };
    case STATE_FETCH_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case SET_LANGUAGE:
      return {
        ...state,
        language: action.language,
      };
    case TOGGLE_MESSAGE_COLLAPSED:
      newMessages = [...state.data.messages];
      newMessages[action.userMessage.index] = {
        ...newMessages[action.userMessage.index],
        isCollapsed: !action.userMessage.isOpen,
      };
      return {
        ...state,
        data: {
          ...state.data,
          messages: newMessages,
        },
      };
    default:
      return state;
  }
};

export default user;
